import Call from '../Call';
import {objToQs} from '../Utils';

const AdkBlock = {
    get(filters) {
        return Call(`adkBlock?${objToQs(filters)}`);
    },

    save(affid, subids) {
        return Call(`adkBlock/${affid}`,'POST', { subids });
    },

    remove(id) {
        return Call(`adkBlock/${id}`,'DELETE');
    }
}

export default AdkBlock;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkBlock.js